import React from 'react';
import ReactDOM from 'react-dom/client';
import { App }from './App';

// ── Service Worker (PWA + Push Notifications) ──
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(() => console.log('[SW] Service Worker registrado.'))
      .catch((err) => console.error('[SW] Erro ao registrar SW:', err));
  });
}
// ──────────────────────────────────────────────

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
